import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import ExpandIcon from '@mui/icons-material/ChevronRight';
import CollapseIcon from '@mui/icons-material/ExpandMore';
import {TreeItem} from '@mui/x-tree-view/TreeItem';
import FolderIcon from 'components/icons/FolderIcon';
import OpenFolderIcon from 'components/icons/OpenFolderIcon';
import {INavState} from 'features/layout/redux/helpers/FoldersHelper';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import classnames from 'classnames';
import {useTreeExpandCollapseContext} from 'components/ContextMenu/hooks/useTreeExpandCollapseContext';
import TreeViewItem from 'components/TreeViewItem';
import {Typography} from '@mui/material';
import {ContextMenuWrapper} from 'features/layout/SideNav/components/ContextMenuButton';

type TreeViewNodeProps = {
   data: INavState;
   style?: React.CSSProperties;
   selected?: boolean;
};

const useStyles = makeStyles((theme) => ({
   root: {
      padding: 0,
   },
   content: {
      padding: 0,
      background: theme.palette.background.default,
      marginLeft: 1,
      '.isActiveRoute &': {
         backgroundColor: theme.palette.action.selected,
      },
   },
   selected: {
      backgroundColor: theme.palette.action.selected,
   },
   labelRoot: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 0),
   },

   expandIcon: {
      // position: 'absolute',
      fill: theme.palette.grey[600],
      marginLeft: -3,
   },
   labelIcon: {
      marginRight: '5px',
   },

   iconContainer: {
      '&&&': {
         width: 0,
         marginRight: 0,
      },
   },
}));

const TreeViewNode = ({data, style, selected}: TreeViewNodeProps) => {
   const classes = useStyles();
   const {toggleNode} = useTreeExpandCollapseContext();

   // const {id} = unpackId(data.id);

   if (data.objectType !== DiplomatObjectType.enum.FOLDER) {
      return <TreeViewItem style={style} data={data} />;
   }

   const isRoot = data.level === 0;
   const hasChild = data.child?.length;
   const isExpanded = data._state.expanded; // expanded.some((nodeId: string) => data.id === nodeId);

   return (
      <TreeItem
         style={style}
         classes={{
            root: classes.root,
            content: classes.content,
            iconContainer: classes.iconContainer,
         }}
         className={classnames({
            expanded: isExpanded && !isRoot && hasChild,
            selected,
         })}
         key={data.id}
         nodeId={data.id}
         onClick={() => toggleNode(data.id)}
         label={
            <ContextMenuWrapper data={data} className={classes.labelRoot}>
               {isExpanded ? (
                  <>
                     <CollapseIcon className={classes.expandIcon} />
                     <OpenFolderIcon className={classes.labelIcon} />
                  </>
               ) : (
                  <>
                     <ExpandIcon className={classes.expandIcon} />
                     <FolderIcon className={classes.labelIcon} />
                  </>
               )}
               <Typography variant="body2">{data.name}</Typography>
            </ContextMenuWrapper>
         }
      >
         {/* {data.child?.map((child: INav) => (
            <TreeViewNode key={child.id} data={child} />
         ))} */}
      </TreeItem>
   );
};

export default React.memo(TreeViewNode);
